// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

const uri = "api/custom/subscription/subscribe";
const unSubscribeUri = "api/custom/subscription/unsubscribe";

export interface SubscribeParameter extends ApiParameter {
    email: string;
    isSubscribedToHubSpot: boolean;
}

export async function subscribeCustom(parameter: SubscribeParameter): Promise<ServiceResult<any>> {
    try {
        const result = await post<SubscribeParameter>(
            `${parameter.isSubscribedToHubSpot ? uri : unSubscribeUri}?email=${parameter.email}`,
        );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message,
            };
        }
        throw error;
    }
}
